var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import React from 'react';
import { FormatType } from '@util/enums';
import numbro from 'numbro';
import { Component } from 'react';
import RelativePortal from 'react-relative-portal';
import * as V from 'victory';
import { appColors } from '@styled/useTheme';
import { ChartType, getTextWidth } from './util';
var fontFamily = '"Inter", sans-serif';
var fontSize = '13px';
function calculateBarWidth(boxWidth, numberOfBarsPerGroup, numberOfLabels) {
    var barWidthWithOffset = 1;
    var calc = boxWidth / (numberOfBarsPerGroup * 1.5 * numberOfLabels);
    barWidthWithOffset = calc > barWidthWithOffset ? calc : 1;
    return {
        barWidth: Math.round(barWidthWithOffset / 1.5),
        barOffset: Math.round(barWidthWithOffset),
    };
}
var VChart = /** @class */ (function (_super) {
    __extends(VChart, _super);
    function VChart(props) {
        var _this = _super.call(this, props) || this;
        _this.generateRandomKey = function () {
            return "key-".concat(Math.floor(Math.random() * 900000) + 100000);
        };
        _this.state = { key: _this.generateRandomKey() };
        return _this;
    }
    VChart.prototype.componentDidUpdate = function (prevProps) {
        if (JSON.stringify(this.props) !== JSON.stringify(prevProps)) {
            this.setState({ key: this.generateRandomKey() });
        }
    };
    VChart.prototype.render = function () {
        var e_1, _a;
        var _this = this;
        var _b, _c, _d, _e, _f;
        var _g = this.props, wId = _g.wId, data = _g.data, containerWidth = _g.containerWidth, containerHeight = _g.containerHeight, horizontal = _g.horizontal, showLabels = _g.showLabels, formatter = _g.formatter;
        var _h = this.props.data, labels = _h.labels, numberOfBars = _h.numberOfBars, lines = _h.lines;
        var barLines = [];
        var lineLines = [];
        var areaLines = [];
        var min = Math.round(getTextWidth(numbro(data.minValue).format({ thousandSeparated: true, mantissa: 2 }), fontSize, fontFamily));
        var max = Math.round(getTextWidth(numbro(data.maxValue).format({ thousandSeparated: true, mantissa: 2 }), fontSize, fontFamily));
        var paddingLeft = Math.max(max, min) + 15;
        paddingLeft = paddingLeft > 30 ? paddingLeft : 30;
        var respChart = calculateBarWidth(containerWidth - (paddingLeft + 10), numberOfBars, labels.length);
        lines.forEach(function (stackedItem, i) {
            if (stackedItem.chartType === ChartType.AREA) {
                areaLines.push(React.createElement(V.VictoryStack, { key: "area-stack-".concat(i), name: "area-stack-".concat(i) }, stackedItem.lineData.map(function (d, idx) {
                    return (React.createElement(V.VictoryGroup, { key: "area-group-".concat(i, "-").concat(idx), name: "area-group-".concat(i, "-").concat(idx), data: d.points },
                        React.createElement(V.VictoryArea, { key: "area-".concat(i, "-").concat(idx), name: "area-".concat(i, "-").concat(idx), style: {
                                data: {
                                    fill: d.color,
                                    fillOpacity: 0.7,
                                },
                                labels: { fontFamily: fontFamily },
                            }, labels: function (_a) {
                                var datum = _a.datum;
                                return (showLabels &&
                                    _this.props.labels &&
                                    formatter(datum.y, _this.props.labels.numFmt)) ||
                                    '';
                            } })));
                })));
            }
            else if (stackedItem.chartType === ChartType.BAR) {
                barLines.push(React.createElement(V.VictoryStack, { key: "bar-stack-".concat(i), name: "bar-stack-".concat(i) }, stackedItem.lineData.map(function (d, idx) {
                    var dataWithWidth = d.points.map(function (d) {
                        d.width = respChart.barWidth;
                        return d;
                    });
                    return (React.createElement(V.VictoryBar, { key: "bar-".concat(i, "-").concat(idx), name: "bar-".concat(i, "-").concat(idx), data: dataWithWidth, labels: function (_a) {
                            var datum = _a.datum;
                            return (showLabels &&
                                _this.props.labels &&
                                formatter(datum.y, _this.props.labels.numFmt)) ||
                                '';
                        }, labelComponent: React.createElement(V.VictoryLabel, null), style: {
                            data: {
                                fill: d.color,
                            },
                            labels: { fontFamily: fontFamily },
                        }, alignment: "middle" }));
                })));
            }
            else if (stackedItem.chartType === ChartType.LINE) {
                lineLines.push(React.createElement(V.VictoryStack, { key: "line-stack-".concat(i), name: "line-stack-".concat(i) }, stackedItem.lineData.map(function (d, idx) {
                    return (React.createElement(V.VictoryGroup, { key: "line-group-".concat(i, "-").concat(idx), name: "line-group-".concat(i, "-").concat(idx), data: d.points, color: d.color },
                        React.createElement(V.VictoryLine, { key: "line-".concat(i, "-").concat(idx), name: "line-".concat(i, "-").concat(idx), labels: function (_a) {
                                var datum = _a.datum;
                                return (showLabels &&
                                    _this.props.labels &&
                                    formatter(datum.y, _this.props.labels.numFmt)) ||
                                    '';
                            }, style: {
                                labels: { fontFamily: fontFamily },
                            } })));
                })));
            }
        });
        var shouldHideAxis = this.props.pie || this.props.hideAxis;
        if (this.props.pie) {
            var pieData = [];
            var colorScale = [];
            var sum_1 = 0;
            try {
                for (var _j = __values(data.lines), _k = _j.next(); !_k.done; _k = _j.next()) {
                    var pie = _k.value;
                    var point = (_d = (_c = (_b = pie.lineData) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.points) === null || _d === void 0 ? void 0 : _d[0];
                    var color = (_f = (_e = pie.lineData) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.color;
                    if (!point || !point.y) {
                        continue;
                    }
                    var yValue = Math.abs(point.y);
                    sum_1 += yValue;
                    colorScale.push(color);
                    pieData.push({ x: point.title, y: yValue });
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_k && !_k.done && (_a = _j.return)) _a.call(_j);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return (React.createElement(V.VictoryPie, { data: pieData, colorScale: colorScale, animate: { duration: 200, onLoad: { duration: 0 } }, width: containerWidth, height: containerHeight, padding: {
                    left: 10,
                    top: 45,
                    right: 10,
                    bottom: 45,
                }, style: {
                    labels: { fontFamily: fontFamily },
                }, labels: function (_a) {
                    var _b, _c;
                    var datum = _a.datum;
                    if (!showLabels || (datum.y / sum_1) * 100 < 2.5) {
                        return '';
                    }
                    if (((_c = (_b = _this.props) === null || _b === void 0 ? void 0 : _b.labels) === null || _c === void 0 ? void 0 : _c.type) === FormatType.PERCENTAGE) {
                        return "".concat(formatter(datum.y / sum_1, _this.props.labels.numFmt));
                    }
                    if (showLabels && _this.props.labels) {
                        return formatter(datum.y, _this.props.labels.numFmt);
                    }
                    return '';
                } }));
        }
        return (React.createElement("div", { key: this.state.key, id: "vc-conatiner-".concat(wId), style: { textAlign: 'center', width: '100%' } },
            React.createElement(V.VictoryChart, { horizontal: !!horizontal, animate: { duration: 200, onLoad: { duration: 0 } }, width: containerWidth, height: containerHeight, style: {
                    parent: {
                        margin: '0 auto',
                    },
                    //@ts-ignore
                    axis: { stroke: appColors.neutral400 },
                    //@ts-ignore
                    grid: { stroke: null },
                }, padding: {
                    bottom: 45,
                    top: 30,
                    right: 60,
                    left: horizontal ? 120 : 60,
                }, defaultAxes: undefined, containerComponent: React.createElement(V.VictoryVoronoiContainer, { voronoiDimension: "x", labels: function (d) { return d.datum.title; }, 
                    //@ts-ignore
                    labelComponent: React.createElement(CustomLabel, { labels: labels }) }) },
                shouldHideAxis ? null : (React.createElement(V.VictoryAxis, { dependentAxis: true, style: {
                        axis: { stroke: appColors.neutral.w400 },
                        axisLabel: { textAlign: 'center' },
                        grid: { stroke: appColors.neutral.w400 },
                        //@ts-ignore
                        ticks: { size: 5, color: appColors.ui.dark },
                        tickLabels: {
                            fontSize: fontSize,
                            fontFamily: fontFamily,
                            padding: 5,
                            fill: appColors.ui.dark,
                        },
                    }, tickFormat: function (tick) {
                        return numbro(tick).format({
                            thousandSeparated: true,
                            mantissa: 2,
                            average: true,
                            totalLength: 3,
                        });
                    } })),
                /* AREA & AREA STACKED*/
                areaLines.length > 0 && areaLines,
                /* BARS & BARS STACKED */
                React.createElement(V.VictoryGroup, { key: "bar-group-0-0", name: "bar-group-0-0", offset: respChart.barOffset }, barLines),
                /* LINES & LINES STACKED*/
                lineLines.length > 0 && lineLines,
                //@ts-ignore
                React.createElement(V.VictoryAxis, { tickValues: labels, fixLabelOverlap: true, style: {
                        axis: { stroke: appColors.neutral.w400 },
                        axisLabel: { textAlign: 'center' },
                        grid: { stroke: null },
                        ticks: { size: 5, color: appColors.ui.dark },
                        tickLabels: {
                            fontSize: fontSize,
                            fontFamily: fontFamily,
                            fill: appColors.ui.dark,
                        },
                    } }))));
    };
    return VChart;
}(Component));
var CustomLabel = /** @class */ (function (_super) {
    __extends(CustomLabel, _super);
    function CustomLabel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CustomLabel.prototype.render = function () {
        var _a = this.props, activePoints = _a.activePoints, labels = _a.labels, x = _a.x, y = _a.y;
        var mainLabel;
        var popoverLines = activePoints.map(function (p, idx) {
            if (idx === 0) {
                mainLabel = labels[p.x - 1];
            }
            return (React.createElement("small", { key: idx, style: {
                    display: 'block',
                    position: 'relative',
                } },
                React.createElement("div", null, "".concat(p.title, ": "),
                    React.createElement("b", null, !!p.y
                        ? numbro(p.y).format({
                            thousandSeparated: true,
                            mantissa: 2,
                            average: true,
                            totalLength: 4,
                        })
                        : ''))));
        });
        return (React.createElement("g", { transform: "translate(".concat(x + 5, ", ").concat(y + 5, ")") },
            React.createElement("foreignObject", null,
                React.createElement(RelativePortal, { component: "div" },
                    React.createElement("div", { style: {
                            background: '#fff',
                            border: '1px solid #ddd',
                            width: 'auto',
                            height: 'auto',
                            textAlign: 'left',
                            padding: '10px',
                            boxShadow: '2px 2px 5px grey',
                            pointerEvents: 'none',
                        } },
                        React.createElement("b", null, mainLabel),
                        popoverLines)))));
    };
    return CustomLabel;
}(Component));
export default VChart;
